export const ActionTypes = {
    SET_USER_LOGIN: 'SET_USER_LOGIN',
    SET_TRIP: 'SET_TRIP',
    SET_DATE: 'SET_DATE',
    SET_MODAL_JOURNEY: 'SET_MODAL_JOURNEY',
    SET_MODAL_TRIP_INFO: 'SET_MODAL_TRIP_INFO',
    SET_LIST_SEARCH: 'SET_LIST_SEARCH',
}